import React, { Component } from "react";
import { leadType } from "../../../../app";
import { ALDDApis } from "../../../../ddAl/apis/aLDDApis";
import commonContext, { AppContext } from "../../../context/common";
import { Utilities } from "../../../utils/utilities";

class LoanSummary extends Component<{}, {}> {
    static contextType = commonContext;
    lead: leadType;
    setLead: Function;
    base: String;
    apis: ALDDApis;
    utils: Utilities;
    componentDidMount() {
        this.setLead = (this.context as AppContext).setLead;
        this.base = (this.context as AppContext).base;
        this.apis = (this.context as AppContext).apis;
        this.utils = (this.context as AppContext).utils as Utilities;
        this.lead = (this.context as AppContext).lead as leadType;

        let totalLoanAmount =
            parseFloat(this.lead.desiredLoanAmount) +
            (this.lead.insuranceAvailed
                ? parseFloat(this.lead.insuranceSsiPremium)
                : 0);
        let totalAmount =
            totalLoanAmount -
            parseFloat(this.lead.stampDuty) -
            parseFloat(this.lead.processingFees) -
            this.lead.collateralCharges;
        let marginMoneyPaid =
            parseFloat(this.lead.finalCarPrice) -
            parseFloat(this.lead.desiredLoanAmount);
        this.setLead({
            totalLoanAmount,
            totalAmount,
            marginMoneyPaid,
        });
    }
    render() {
        this.lead = (this.context as AppContext).lead as leadType;
        this.utils = (this.context as AppContext).utils as Utilities;
        this.base = (this.context as AppContext).base;
        return (
            <>
                <div className="relative w-full">
                    <div className="relative w-full  md:w-2/3 lg:w-2/3 xl:w-2/3 rounded-lg lighter-blue px-3 py-3 md:px-5 md:py-5 xl:px-8 xlpy-8">
                        <ul className="flex flex-wrap justify-between flex-row lg:flex-row">
                            <li className="mb-2 lg:mb-0">
                                <label className="openSans-Reg text-sm md:text-lg xl:text-xl text-gray-500">
                                    EMI
                                </label>
                                <p className="openSans-SemiBold text-black text-lg md:text-2xl xl:text-2xl relative">
                                    <span className="left-0 WebRupee">Rs.</span>{" "}
                                    {this.utils?.currencyFormat(this.lead.emi)}
                                </p>
                            </li>
                            <li className="mb-2 lg:mb-0">
                                <label className="openSans-Reg text-sm md:text-lg xl:text-xl text-gray-500">
                                    Interest Rate
                                </label>
                                <p className="openSans-SemiBold text-black text-lg md:text-2xl xl:text-2xl ">
                                    {this.lead.interestRate}%
                                </p>
                            </li>
                            <li className="mb-0 lg:mb-0">
                                <label className="openSans-Reg text-sm md:text-lg xl:text-xl text-gray-500">
                                    Processing Fees
                                </label>
                                <p className="openSans-SemiBold text-black text-lg md:text-2xl xl:text-2xl  relative">
                                    <span className="left-0 WebRupee">Rs.</span>{" "}
                                    {this.utils?.currencyFormat(
                                        this.lead.processingFees
                                    )}
                                </p>
                            </li>
                        </ul>
                    </div>
                </div>
                {this.base != "qm-10-seconds" ? (
                    <>
                        <div className="relative w-full">
                            <div className="relative w-full md:w-1/2 lg:w-1/2 xl:w-1/2 rounded-lg lighter-blue-2 px-3 py-3 md:px-5 md:py-5 xl:px-8 xlpy-8 my-6 md:my-8">
                                <h3 className="w-full md:w-10/12 openSans-Reg text-black text-2xl md:text-3xl lg:text-4xl mb-5">
                                    Your Contribution to Dealer
                                </h3>
                                <div className="w-full border-t lightborder py-3">
                                    <div className="w-full flex flex-wrap items-center">
                                        <p className="w-1/2 text-left openSans-Reg text-sm md:text-lg xl:text-xl text-track">
                                            Margin Money
                                        </p>
                                        <p className="w-1/2 text-right openSans-SemiBold text-black text-2xl md:text-2xl lg:text-3xl relative pl-4">
                                            <span className="WebRupee">
                                                Rs.
                                            </span>{" "}
                                            <span>
                                                {this.lead.marginMoneyPaid
                                                    ? this.utils.currencyFormat(
                                                          this.lead
                                                              .marginMoneyPaid
                                                      )
                                                    : "0"}
                                            </span>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                ) : (
                    ""
                )}

                <div className="relative w-full">
                    <div className="relative w-full md:w-1/2 lg:w-1/2 xl:w-1/2 rounded-lg lighter-blue-2 px-3 py-3 md:px-5 md:py-5 xl:px-8 xlpy-8 my-6 md:my-8">
                        <h3 className="w-full md:w-10/12 openSans-Reg text-black text-2xl md:text-3xl lg:text-4xl mb-5">
                            Total Disbursement Amount
                        </h3>
                        <div className="w-full">
                            <div className="w-full flex flex-wrap items-center mb-3">
                                <div className="w-full flex flex-wrap items-center mb-2">
                                    <p className="w-1/2 text-left openSans-Reg text-sm md:text-lg xl:text-xl text-track">
                                        Desired Amount
                                    </p>
                                    <p className="w-1/2 text-right openSans-SemiBold text-black text-lg md:text-2xl xl:text-2xl  relative pl-4">
                                        <span className="WebRupee">Rs.</span>{" "}
                                        <span>
                                            {this.utils.currencyFormat(
                                                this.lead.desiredLoanAmount
                                            )}
                                        </span>{" "}
                                    </p>
                                </div>
                                {this.lead.roadTaxInsuranceAvailed ? (
                                    <>
                                        <div className="w-full flex flex-wrap items-center mb-2">
                                            <p className="w-1/2 text-left openSans-Reg text-sm md:text-lg xl:text-xl text-track">
                                                Road Tax
                                            </p>
                                            <p className="w-1/2 text-right openSans-SemiBold text-black text-lg md:text-2xl xl:text-2xl  relative pl-4">
                                                +{" "}
                                                <span className="WebRupee">
                                                    Rs.
                                                </span>{" "}
                                                <span>
                                                    {this.utils.currencyFormat(
                                                        parseFloat(
                                                            this.lead
                                                                .rtoEditAmount
                                                        )
                                                    )}
                                                </span>{" "}
                                            </p>
                                        </div>
                                    </>
                                ) : (
                                    ""
                                )}
                                {this.lead.motorInsuranceAvailed ? (
                                    <>
                                        <div className="w-full flex flex-wrap items-center mb-2">
                                            <p className="w-1/2 text-left openSans-Reg text-sm md:text-lg xl:text-xl text-track">
                                                {this.base == "qm-10-seconds"
                                                    ? "HDFC Motor Insurance"
                                                    : "HDFC ERGO Insurance"}
                                            </p>
                                            <p className="w-1/2 text-right openSans-SemiBold text-black text-lg md:text-2xl xl:text-2xl  relative pl-4">
                                                +{" "}
                                                <span className="WebRupee">
                                                    Rs.
                                                </span>{" "}
                                                <span>
                                                    {this.utils.currencyFormat(
                                                        this.lead
                                                            .motorInsuranceAvailed
                                                            ? this.lead
                                                                  .motorInsurancePremium
                                                                ? parseFloat(
                                                                      this.lead
                                                                          .motorInsurancePremium
                                                                  )
                                                                : parseFloat(
                                                                      this.lead
                                                                          .motorInsurancePremAmt
                                                                  )
                                                            : 0
                                                    )}
                                                </span>{" "}
                                            </p>
                                        </div>
                                    </>
                                ) : (
                                    ""
                                )}
                                {this.lead.dealerInsuranceAvailed ? (
                                    <>
                                        <div className="w-full flex flex-wrap items-center mb-2">
                                            <p className="w-1/2 text-left openSans-Reg text-sm md:text-lg xl:text-xl text-track">
                                                Dealer Insurance
                                            </p>
                                            <p className="w-1/2 text-right openSans-SemiBold text-black text-lg md:text-2xl xl:text-2xl  relative pl-4">
                                                +{" "}
                                                <span className="WebRupee">
                                                    Rs.
                                                </span>{" "}
                                                <span>
                                                    {this.utils.currencyFormat(
                                                        parseFloat(
                                                            this.lead
                                                                .dealerInsuranceAmtEdit
                                                        )
                                                    )}
                                                </span>{" "}
                                            </p>
                                        </div>
                                    </>
                                ) : (
                                    ""
                                )}
                                {this.lead.insuranceAvailed ? (
                                    <>
                                        <div className="w-full flex flex-wrap items-center mb-2">
                                            <p className="w-1/2 text-left openSans-Reg text-sm md:text-lg xl:text-xl text-track">
                                                Sarv Surksha Premium
                                            </p>
                                            <p className="w-1/2 text-right openSans-SemiBold text-black text-lg md:text-2xl xl:text-2xl  relative pl-4">
                                                +{" "}
                                                <span className="WebRupee">
                                                    Rs.
                                                </span>{" "}
                                                <span>
                                                    {this.utils.currencyFormat(
                                                        parseFloat(
                                                            this.lead
                                                                .insuranceSsiPremium
                                                        )
                                                    )}
                                                </span>{" "}
                                            </p>
                                        </div>
                                    </>
                                ) : (
                                    ""
                                )}
                                <div className="w-full flex flex-wrap items-center mb-2">
                                    <p className="w-1/2 text-left openSans-Reg text-sm md:text-lg xl:text-xl text-track">
                                        <b>Total Loan Amount</b>
                                    </p>
                                    <p className="w-1/2 text-right openSans-SemiBold text-black text-lg md:text-2xl xl:text-2xl  relative pl-4">
                                        <span className="WebRupee">Rs.</span>{" "}
                                        <span>
                                            {this.utils.currencyFormat(
                                                this.lead.totalLoanAmount
                                            )}
                                        </span>{" "}
                                    </p>
                                </div>
                                {this.lead.motorInsuranceAvailed ? (
                                    <>
                                        <div className="w-full flex flex-wrap items-center mb-2">
                                            <p className="w-1/2 text-left openSans-Reg text-sm md:text-lg xl:text-xl text-track">
                                                {this.base == "qm-10-seconds"
                                                    ? "HDFC Motor Insurance"
                                                    : "HDFC ERGO Insurance"}
                                            </p>
                                            <p className="w-1/2 text-right openSans-SemiBold text-black text-lg md:text-2xl xl:text-2xl  relative pl-4">
                                                -{" "}
                                                <span className="WebRupee">
                                                    Rs.
                                                </span>{" "}
                                                <span>
                                                    {this.utils.currencyFormat(
                                                        this.lead
                                                            .motorInsuranceAvailed
                                                            ? this.lead
                                                                  .motorInsurancePremium
                                                                ? parseFloat(
                                                                      this.lead
                                                                          .motorInsurancePremium
                                                                  )
                                                                : parseFloat(
                                                                      this.lead
                                                                          .motorInsurancePremAmt
                                                                  )
                                                            : 0
                                                    )}
                                                </span>{" "}
                                            </p>
                                        </div>
                                    </>
                                ) : (
                                    ""
                                )}

                                {this.lead.insuranceAvailed ? (
                                    <>
                                        <div className="w-full flex flex-wrap items-center mb-2">
                                            <p className="w-1/2 text-left openSans-Reg text-sm md:text-lg xl:text-xl text-track">
                                                Sarv Surksha Premium
                                            </p>
                                            <p className="w-1/2 text-right openSans-SemiBold text-black text-lg md:text-2xl xl:text-2xl  relative pl-4">
                                                -{" "}
                                                <span className="WebRupee">
                                                    Rs.
                                                </span>{" "}
                                                <span>
                                                    {this.utils.currencyFormat(
                                                        parseFloat(
                                                            this.lead
                                                                .insuranceSsiPremium
                                                        )
                                                    )}
                                                </span>{" "}
                                            </p>
                                        </div>
                                    </>
                                ) : (
                                    ""
                                )}
                            </div>

                            <p className="openSans-SemiBold text-sm md:text-lg xl:text-xl text-black mb-3">
                                Bank Charges
                            </p>
                            <div className="w-full flex flex-wrap items-center mb-2">
                                <p className="w-1/2 text-left openSans-Reg text-sm md:text-lg xl:text-xl text-track">
                                    Stamp Duty
                                </p>
                                <p className="w-1/2 text-right openSans-SemiBold text-black text-lg md:text-2xl xl:text-2xl  relative pl-4">
                                    - <span className="WebRupee">Rs.</span>{" "}
                                    <span>
                                        {this.utils.currencyFormat(
                                            this.lead.stampDuty
                                        )}
                                    </span>{" "}
                                </p>
                            </div>

                            <div className="w-full flex flex-wrap items-center mb-2">
                                <p className="w-1/2 text-left openSans-Reg text-sm md:text-lg xl:text-xl text-track">
                                    Collateral Charges
                                </p>
                                <p className="w-1/2 text-right openSans-SemiBold text-black text-lg md:text-2xl xl:text-2xl  relative pl-4">
                                    - <span className="WebRupee">Rs.</span>{" "}
                                    <span>{this.lead.collateralCharges}</span>{" "}
                                </p>
                            </div>

                            <div className="w-full flex flex-wrap items-center mb-3">
                                <p className="w-1/2 text-left openSans-Reg text-sm md:text-lg xl:text-xl text-track">
                                    Bank Processing Fees
                                </p>
                                <p className="w-1/2 text-right openSans-SemiBold text-black text-lg md:text-2xl xl:text-2xl  relative pl-4">
                                    - <span className="WebRupee">Rs.</span>{" "}
                                    <span>
                                        {this.utils.currencyFormat(
                                            this.lead.processingFees
                                        )}
                                    </span>
                                </p>
                            </div>

                            <div className="w-full border-t lightborder py-3">
                                <div className="w-full flex flex-wrap items-center">
                                    <p className="w-1/2 text-left openSans-Reg text-sm md:text-lg xl:text-xl text-black">
                                        Total Amount
                                    </p>
                                    <p className="w-1/2 text-right openSans-SemiBold text-black text-2xl md:text-2xl lg:text-3xl relative pl-4">
                                        <span className="WebRupee">Rs.</span>{" "}
                                        <span>
                                            {this.utils.currencyFormat(
                                                this.lead.liLoanAmount
                                            )}
                                        </span>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

export default LoanSummary;
